import React, {useState} from 'react';
import deleteIcon from '../../app-main-content/icons/DeleteItem.svg'
import reset from '../../app-main-content/icons/Reset.svg'
import Genres from '../../adminContent/AdminFilters/Genres'
import Moods from '../../adminContent/AdminFilters/Moods'
import Artists from '../../adminContent/AdminFilters/Artists'
import Composers from '../../adminContent/AdminFilters/Composers'
import Tags from '../../adminContent/AdminFilters/Tags'
import VideoGenre from '../../adminContent/AdminFilters/VideoGenre'
import whiteSearchIcon from '../adminIcons/whiteSearch.svg'

function AdminFilter(props) {

    const deleteHandler = (item) =>{
        props.setFilterList((prevArr) => prevArr.filter(i => i !== item))
    }

    const filterGo = () => {
        if (props.filterList.length){
            props.setPage(1)
            props.setIndex(2)
            props.setStateChanged(!props.stateChanged);
        }
    }

    return (
        <div className = 'w-100 pb-2 pb-lg-2 mt-4 bg-success d-flex justify-content-center rounded'>
            <div className = 'col-12 pt-3 d-flex flex-column px-3'>
                <div className = 'col-12 d-flex align-items-center align-items-lg-end flex-column flex-wrap flex-lg-row flex-md-row justify-content-center justify-content-md-around justify-content-lg-between'>
                    <Artists
                        index = {1}
                        filterList = {props.filterList}
                        setFilterList = {props.setFilterList}
                    />
                    <Composers
                        index = {1}
                        filterList = {props.filterList}
                        setFilterList = {props.setFilterList}
                    />
                    <Genres
                        index = {1}
                        filterList = {props.filterList}
                        setFilterList = {props.setFilterList}
                    />
                    <VideoGenre
                        index = {1}
                        filterList = {props.filterList}
                        setFilterList = {props.setFilterList}
                    />
                    <Moods
                        index = {1}
                        filterList = {props.filterList}
                        setFilterList = {props.setFilterList}
                    />
                    <Tags
                        index = {1}
                        filterList = {props.filterList}
                        setFilterList = {props.setFilterList}
                    />

                    <div className = 'd-flex py-2 justify-content-center justify-content-md-start align-items-center' id="admin-find-buttons">
                        <div className='d-flex align-items-center' style={{gap:"0.5rem"}}>
                            <img   
                                style={{width:"2rem"}}
                                src = {reset}
                                alt = ""
                                role = "button" onClick={()=>props.setFilterList([])}/>
                            <div className = 'py-2 px-1 bg-secondary text-white rounded-circle d-flex justify-content-center align-items-center' 
                                role = "button" onClick = {()=>{filterGo()}}>
                                <img className = 'px-2 py-1' src = {whiteSearchIcon} alt = ''/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className = 'px-2 position-relative pt-3 d-flex flex-column flex-lg-row justify-content-center align-items-center'>
                    <div className = 'col-12 d-flex flex-wrap flex-row'>
                        {
                            props.filterList && props.filterList.length ? 
                            props.filterList.map((item, i) => 
                            <div className = "d-flex flex-row align-items-center text-wrap text-lg-nowrap me-2 mb-2" key = {i} >
                                <div className = "fs-sm text-secondary me-1">{item[1]}</div>
                                <img 
                                    role="button"
                                    src = {deleteIcon} 
                                    alt = "" onClick={()=>deleteHandler(item)}/>
                            </div>) : ''
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminFilter;